var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-helper"},[_c('a-card',{attrs:{"title":"发布助手"}},[_c('a-icon',{attrs:{"slot":"extra","type":"down"},slot:"extra"}),_c('p',[_vm._v("Hi，我是发布助手～可以实时检测内容提出优化建议，帮你提升商品内容质量。")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }